import clsx from 'clsx'
import type { ReactNode } from 'react'
import { ScrollView } from 'react-native'

import type { TNotificationApi } from '@/src/features/notification/api/types/notificationApi.types'
import {
  anyIntentionFinishedNotificationTypes,
  type NOTIFICATION_TYPE,
} from '@/src/features/notification/models/notification.constants'
import type { TAnyIntentionFinishedNotificationTypes } from '@/src/features/notification/models/notification.types'
import { useNotificationsQuery } from '@/src/features/notification/services/useNotificationsQuery'
import { useDimensions } from '@/src/general/hooks/useDimensions'

import { IntentionNotificationMessage } from './IntentionNotificationMessage'

const isIntentionNotification = (
  notification: TNotificationApi,
): notification is TNotificationApi<TAnyIntentionFinishedNotificationTypes> =>
  (anyIntentionFinishedNotificationTypes as readonly NOTIFICATION_TYPE[]).includes(notification.type)

export const IntentionNotificationMessages = (): ReactNode => {
  const { data: notifications } = useNotificationsQuery()
  const { xs } = useDimensions()

  const intentionNotifications = notifications?.filter(isIntentionNotification)
  const isHorizontal = xs && intentionNotifications && intentionNotifications.length > 1

  return (
    <ScrollView horizontal={isHorizontal} className="no-scrollbar -mx-5 grow-0" contentContainerClassName="gap-4 px-5">
      {intentionNotifications?.map((notification) => (
        <IntentionNotificationMessage
          className={clsx({ 'w-[80vw]': isHorizontal, 'w-full': !isHorizontal })}
          key={notification.id}
          notification={notification}
        />
      ))}
    </ScrollView>
  )
}
